/**
 * Tab ids of the skill-up admin panels, shared between the manifest and the
 * views that programmatically open/activate them.
 */
export const SKILL_UP_NODE_PREVIEW_TAB = 'skill-up-node-preview';
